import { defineMessages } from "react-intl";

export const messages = defineMessages({
  buttonLabel: {
    id: "userSelectField.renderOption.button.add.label",
    defaultMessage: "Add",
    description: "Button label",
  },
});
